<template>
  <BlurPage>
    <div class="add-label-content">
      <main class="label-name">
        <label for="newlLabel">标签名:</label>
        <input name="newlLabel" type="text" v-model="value" />
        <div class="Intelligence_selection">
          <label for="newlLabel" style="margin-right:4%">情报选择:</label>
          <el-radio-group v-model="resource">
            <el-radio :label="94">战略情报</el-radio>
            <el-radio :label="95">战役情报</el-radio>
          </el-radio-group>
        </div>
      </main>
      <footer class="btns">
        <el-button type="primary" class="btn" @click="handleAdd">确定</el-button>
        <el-button type="primary" class="btn" @click="closeupd">取消</el-button>
      </footer>
    </div>
  </BlurPage>
</template>

<script>
import BlurPage from "../BlurPage/index.vue"
import api from "@/services/python"
export default {
  components: {
    BlurPage,
  },
  data() {
    return {
      value: "",
      resource:""
    }
  },
  methods: {
    closeupd(){
      this.$emit("cancel")
    },
   async handleAdd() {
     const params = {
        name:this.value,
        "id": 0,
        "category_id": this.resource,
        domain_id: 3
     }
      const res =await api.keywords.create(params).response.then(res => res.data)
       if(res.code == 200){
        this.$message({
          message: '添加成功',
          type: 'success',
        });
       }else{
          this.$message.error('添加失败');
       }
       this.$emit("cancel");
      // this.$emit("addNewLable", this.value)
      console.log(res);
    },
  },
}
</script>

<style lang="scss">
$border: 2px solid #aaa;
$inner-border: 1px solid #aaa;
$innerLight: rgba(
  $color: #bce6ec,
  $alpha: 0.5,
);
.add-label-content {
  position: relative;
  width: 30%;
  height: 30%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: $border;
  border-radius: 10px;
  background-color: #030b32;
  & > .label-name {
    width: 100%;
    text-align: center;
    position: relative;
    top: -10%;
    & > input {
      margin-left: 2%;
      border: $inner-border;
      height: 3vh;
      width: 60%;
      border-radius: 8px;
      color: #eee;
      font-size: 14px;
    }
  }
  & > .btns {
    height: 20%;
    position: absolute;
    bottom: 5%;
    display: flex;
    & .btn {
      width: 5vw;
      height: 80%;
      // border: $inner-border;
      border-radius: 4px;
      font-size: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 0 0 1em $innerLight inset;
      background-color: rgb(8, 14, 32);
      border: none;
      cursor: pointer;
      &:hover {
        background-color: #212a4b;
      }
    }
  }
}
.Intelligence_selection{
  margin-top: 8%;
}
</style>
